import React from "react";
import Navbar1Combine from "./Header/Navbar1Combine";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router} from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "./Footer/footer";
import banner1 from "./images/sikkimimages/banner.png";
class Privacy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Tabcontent: "Inclusions",
    };
  }
  render() {
    return (
      <Container fluid className="p-0 m-0">
        <Router>
          <Navbar1Combine />
          <div className="p-0 m-0 aboutuscommonbannerall">
            <img
              src={banner1}
              className="forwebsite"
              alt=""
              style={{ width: "100%" }}
            ></img>
            <img src={banner1} alt="" className="aboutwidth formobile"></img>
          </div>
          <Container className="destinationcard">
            <h1 className="sectionheading">Privacy Policy</h1>
            <div className="geeks"></div>
            <h5 className="termphnfont">
              We care about your privacy as deeply as we care about creating
              amazing travel experiences for you.
            </h5>
            <Row>
              <Col x lg="12" className="termsconditionmaindivfont">
                <p className="privacypara privacyparafont mb-2">
                  <b className="privacyhead">Disclaimer</b>
                </p>
                <ul className="privacylist privacylistfont">
                  <li>
                    All sections within{" "}
                    <b className="numberPolicytext">www.holexo.com </b> domain
                    has been developed and maintained by holxo holidays.
                  </li>
                  <li className="my-3">
                    Holxo is an online travel platform and under no conditions
                    it should be assumed to be an Official / Special Agent / GSA
                    for any Hotel / Resort / Excursion operator.
                  </li>
                  <li>
                    All information contained herein is verified by our experts
                    but Holxo does not take any responsibility for any loss on
                    account of information contained as the viewers are expected
                    to take their own decisions and form their own judgments
                    based on information available. When in doubt, before making
                    a reservation the valuable customers are expected to raise
                    queries and clarify issues if any.
                  </li>
                  <li className="my-3">
                    We try our best to ensure the information provided is the
                    most up to date and accurate, however, we cannot guarantee
                    its accuracy all of the time. We have made every effort to
                    provide correct, complete and up-to-date information from
                    reliable sources , however, we cannot guarantee its accuracy
                    all of the time. In addition, the travel products and
                    services described on the Website are subject to
                    availability.
                  </li>
                  <li className="my-3">
                    Holxo retains the right to refuse any reservation request.
                  </li>
                </ul>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b>Note:</b> Any objections to anything contained on the
                  website should be addressed to which would be dealt promptly.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">General Policies</b>
                  <br />
                  <b>E-mail Policy : </b>
                  We aim to answers all enquiries / other mails in a few working
                  hours on the same day. Our replies are short and crisp,
                  attachments only if necessary.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">
                    {" "}
                    Contact Management Policy / Privacy Policy
                  </b>{" "}
                  <br />
                  All contact details provided by our valuable customers is used
                  with reference to the respective reservation only. Newsletters
                  may be sent regularly with an easy option to unsubscribe.
                  Website does not use Cookies or any technology where
                  information is taken from viewers in background without
                  permission or prior knowledge. All contact details submitted
                  with enquiries are used for internal purpose only and will not
                  be shared / sold to any third-party provider under any
                  circumstances.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">Credit Card Policy</b>
                  <br />
                  Holxo employs multiple payment gateways{" "}
                  <b>(ICICI Bank, Yes Bank, CitrusPay, Amex, etc.).</b> Holxo or
                  any process associated with Holxo website does not store any
                  credit sensitive data such as credit card number for future
                  use. Upon confirmation of bookings, Card details will be asked
                  to be filled on secure pages that employ highest available
                  data encryption and data inputted will be used at that instant
                  for processing online payment. Everytime a user wishes to make
                  payment, one will be required to put card details again and
                  there is no option to store credit card data.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">Hotel Sourcing Policy</b>
                  <br />
                  Holxo surveys and includes stays in their packages that have a
                  certain charm and value for a certain segment of customers.
                  Holxo expressly excludes all hotel options that have suspect
                  management practices, absurdly high tariffs, inappropriate
                  locations and not a very conducive hotel atmosphere.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">Package Prices</b>
                  <br />
                  We offer competitive prices for the packages. GST is charged
                  on our services as per the applicable rates.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">Price Updation</b>
                  <br />
                  We update package prices on the website regularly and reserve
                  right to offer alternatives or to reject any reservation
                  altogether, if we are unable to offer listed prices or rooms
                  for specific dates for any reason beyond our control.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">Refunds</b>
                  <br />
                  Any refunds are subject to guidelines laid out by the
                  respective hotel / resort. Service charges are applicable for
                  processing cancellation (Check Cancellation policy). Refunds
                  for credit card payments will be done via a credit back to the
                  card. In this case MSF (Merchant Service Fee is typically 3%)
                  on refund amount will not be refunded by the bank and
                  therefore be borne by the valuable customer. All refunds will
                  be done after corresponding hotel / service provider refunds /
                  adjustments are done at Holxo end.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">Photographs & Copyright</b>
                  <br />
                  We have used creative common images free for commercial use
                  from the source like shutterstock, unplash, Government
                  official tourism site and others. If you have any issue with
                  the images or if believe that any images used in this site is
                  copyrighted then we request you to inform us about the same on
                  info@holxoholidays.com Please mention the link and details of
                  the issue. We will take necessary action by deleting that
                  image or giving full credit to your site for that subject.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">
                    Policy on refusal of the hotel to accommodate guests
                  </b>
                  <br />
                  Customers are expected to adhere to local laws and Hotel rules
                  during the stay and Holxo shall not be responsible for any
                  refunds if the guest is unable to comply with the local laws /
                  Hotel rules and regulations.
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">
                    Position of Holxo Vis a Vis Hotels / Service Providers
                  </b>
                  <br />
                  <ul className="privacylist privacylistpaddingdown">
                    <li>
                      Holxo is anonline travel platform and it earns revenue
                      from packaging travel arrangements of hotels – resorts and
                      other travel service providers.
                    </li>
                    <li>
                      {" "}
                      Holxo under no conditions should be assumed to be
                      Authorised Agent / Official / Special Agent / GSA for any
                      Hotel / Resort / Service Provider.
                    </li>
                  </ul>
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">
                    Position of Holxo Vis a Vis Deficiency of Service
                  </b>
                  <br />
                  <ul className="privacylist privacylistpaddingdown">
                    <li>
                      Holxo personnel have packaged tours on verified
                      information. All options will not be suitable for all
                      segments of customers and therefore they are expected to
                      take their own decisions and form their own judgments
                      based on information available. When in doubt, before
                      making a reservation the customers are expected to raise
                      queries and clarify issues if any.
                    </li>
                  </ul>
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead" style={{ wordBreak: "break-all" }}>
                    Position of Holxo Vis a Vis Cancellations and postponements
                  </b>
                  <br />
                  <ul className="privacylist privacylistpaddingdown">
                    <li>
                      For any reason if the hotel or service provider or Holxo
                      has cancelled the reservations (Overbooking, wrong booking
                      or any other reason), then immediate refund shall be given
                      to the customer without any deduction.
                    </li>
                    <li>
                      For any cancellation made by the customer, the refund will
                      be given as per the cancellation policy notified to the
                      customer. However, GST amount will not be refunded.
                    </li>
                    <li>
                      Above is not be applicable in cases of cancellation on
                      account of Natural Calamity (Floods, bad weather).
                    </li>
                    <li>
                      All refunds will be made by the same mode as the payment
                      was made. Refunds for credit card payments will be done
                      via a credit back to the card. In this case MSF (Merchant
                      Service Fee as applicable on refund amount will not be
                      refunded by the bank and therefore be borne by the
                      customer. In event of a credit card not in use, customer
                      may be asked to provide alternative means of refunds. Any
                      cost related to the alternative means, will have to be
                      borne by the guest and refund will be paid after deducting
                      the charge.
                    </li>
                  </ul>
                </p>
                <p className="privacypara privacyparafont comonprivactlineheigth">
                  <b className="privacyhead">Cancellation Policy</b>
                  <br /> Holxo applies the cancellation policy as communicated
                  to the customer at the time of making booking. Above is not be
                  applicable in cases of cancellation on account of Natural
                  Calamity (Floods, bad weather)
                  <ul className="privacylist privacylistpaddingdown">
                    <li>
                      GST collected and paid to Government of India is not
                      recoverable and therefore not refunded even in cases of
                      Natural Calamity (Floods, bad weather) and unforeseen
                      travel circumstances.
                    </li>
                  </ul>
                  For any clarification of the above, you may write to{" "}
                  <a
                    className="numberPolicytext"
                    href="mailto:feedback@holxo.com"
                  >
                    feedback@holxo.com
                  </a>
                </p>
              </Col>
            </Row>
          </Container>
          <Footer style={{ margin: "0rem auto auto auto" }} />
        </Router>
      </Container>
    );
  }
}
export default Privacy;
